<template>
  <section :class="$style.autoCompleteWrapper">
    <input
      id="inputAutoComplete"
      ref="inputAutoComplete"
      type="text"
      :class="{ [$style.inputAutoComplete]: true, [$style.error]: !isValid }"
      :placeholder="placeholder"
      v-model="innerValue"
      @blur="$emit('blur')"
      @input="$emit('input', $event.target.value)"
      @change="(newValue, oldValue) => $emit('change', newValue, oldValue)"
    />
    <section :class="$style.suffix">
      <slot name="suffix"></slot>
    </section>
  </section>
</template>

<script>
import loadjs from "loadjs";

const APIKEY = "AIzaSyDh8SNezsOi0aIcq9qLvjHz7zWMP3zcmQg";
const jsPath = `https://maps.googleapis.com/maps/api/js?key=${APIKEY}&libraries=places`;
const loadAutoComplete = () => {
  if (loadjs.isDefined("auto-complete")) {
    return Promise.resolve();
  } else {
    return loadjs([jsPath], "auto-complete", { returnPromise: true });
  }
};

export default {
  name: "InputGoogleAutoComplete",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: [String],
      default: "please enter a address"
    },
    flag: {
      type: [String],
      default: "single"
    },
    iso2: {
      type: [String],
      default: ""
    },
    isValid: [Boolean]
  },
  data() {
    return {
      autoCompleteInstance: null
    };
  },
  components: {},
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    iso2(val) {
      this?.autoCompleteInstance?.setComponentRestrictions?.({
        country: [val?.toLowerCase()]
      });
    }
  },
  methods: {
    initGoogleAutoComplete() {
      const element = this.$refs.inputAutoComplete;
      loadAutoComplete().then(() => {
        const options = {
          types: ["address"],
          fields: [
            "place_id",
            "formatted_address",
            "vicinity",
            "name",
            "address_components"
          ]
        };
        this.autoCompleteInstance = new window.google.maps.places.Autocomplete(
          element,
          options
        );
        this.autoCompleteInstance.addListener(
          "place_changed",
          this.onPlaceChanged
        );
      });
    },
    onPlaceChanged() {
      const place = this.autoCompleteInstance.getPlace();
      if (this.flag === "full") {
        this.$emit("input", place.address_components);
      } else {
        this.$emit("input", place.formatted_address);
      }
    }
  },
  mounted() {
    this.initGoogleAutoComplete();
  }
};
</script>

<style lang="scss" module>
@import "~rfs/scss";

.autoCompleteWrapper {
  position: relative;

  .inputAutoComplete {
    @include rfs(1.25rem);
    @include rfs(3.75rem, min-height);

    width: 100%;
    border-radius: 0.625rem;
    border: solid 0.0625rem #cecbcb;
    padding: 0 1.5625rem;
    color: #0a0a16;

    &:hover,
    &:focus-visible {
      border-color: #cecbcb;
      outline: none;
    }
  }

  .error {
    border: solid 0.0625rem #f41b14;
    &:hover,
    &:focus-visible {
      border-color: #f41b14;
      outline: none;
    }
  }

  .suffix {
    display: flex;
    align-items: center;
    position: absolute;
    z-index: 2;
    right: 12px;
    top: 35%;
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #bfbfbf;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #bfbfbf;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #bfbfbf;
  }

  input::-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #bfbfbf;
  }
}
</style>
